import { React } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import SignupPage from "./components/pages/SignupPage";
import Dashboard from "./components/pages/Dashboard";
import ResumeUpload from "./components/pages/ResumeUpload";
import "./App.css";
import JdForm from "./components/pages/JdForm";
import RecruiterDash from "./components/recuriter/RecruiterDash";
import RJdForm from "./components/recuriter/RJdForm";

import EditForm from "./components/pages/EditForm";
import ThankYou from "./components/pages/ThankYou";
import CandidateQualificationForm from "./components/pages/CandidateQualificationForm";
import AllData from "./components/pages/AllData";
import UserManagement from "./components/pages/User/UserManagement";
import ClientManagement from "./components/pages/ClientManagement";
import AddUser from "./components/pages/User/AddUser";
import AddClient from "./components/pages/AddClient";
import EditClient from "./components/pages/EditClient";
import EditUser from "./components/pages/User/EditUser";
import SetPassword from "./components/pages/SetPassword";
import UserConfirmation from "./components/pages/UserConfirmation";
import CopyJDForm from "./components/pages/CopyJDForm";
import CopyAddUser from "./components/pages/User/CopyAddUser";
import CopyAddClient from "./components/pages/CopyAddClient";
import Footer from "./components/pages/Footer";
import SummaryReport from "./components/pages/SummaryReport";
import SuccessPage from "./components/pages/SuccessPage";
import OnboardingForm from "./components/pages/onboarding/OnboardingForm";
import EmployeeDashboard from "./components/pages/onboarding/EmployeeDashboard";
import CandidateVerificationForm from "./components/pages/onboarding/CandidateVerificationForm";
import { LoadingProvider } from "./components/pages/LoadingContext";
import HomePage from "./components/pages/HomePage";
import LoginPage from "./components/pages/LoginPage";
import AboutUs from "./components/pages/AboutUs";
import ContactPage from "./components/pages/ContactPage";
import AdminLogin from "./components/pages/Admin/AdminLogin";
import AdminDashboard from "./components/pages/Admin/AdminDashboard";
import ApproveAccess from "./components/pages/ApproveAccess";
import ForgotPassword from "./components/pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/pages/ForgotPassword/ResetPassword";
import RecruiterPerformanceDashboard from "./components/pages/MetricsDashboard/RecruiterPerformanceDashboard";
import JdPerformanceDashboard from "./components/pages/MetricsDashboard/JDPerformanceDashboard";
import RecruiterRankingDashboard from "./components/pages/MetricsDashboard/RecruiterRankingDashboard";
import ModuleSelectionPage from "./components/pages/ModuleSelectionPage";
import FreeTrialModal from "./components/pages/FreeTrialModal";
import Blog from "./components/pages/Blogs/Blog";
import BlogPost from "./components/pages/Blogs/BlogPost";
import AiRecruiterPage from "./components/pages/AiRecruiterPage";

// Function to check if the user is authenticated
const isAuthenticated = () => {
  return localStorage.getItem("user_type") !== null;
};

// ProtectedRoute component to protect routes
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  return children;
};

function AppContent() {
  const location = useLocation();
  const showFooter =
    // location.pathname === "/" ||
    location.pathname.includes("/signup") ||
    location.pathname.includes("/admin_login") ||
    location.pathname.includes("/login") ||
    location.pathname.includes("/jd_dashboard") ||
    location.pathname.includes("/user_dashboard") ||
    location.pathname.includes("/client_dashboard") ||
    location.pathname.includes("/reports_dashboard") ||
    location.pathname.includes("/matched_results") ||
    location.pathname.includes("/summary_report") ||
    location.pathname.includes("/employee_dashboard") ||
    location.pathname.includes("/onboarding_form/") ||
    location.pathname.includes("/verification_form/") ||
    location.pathname.includes("/candidate_form/") ||
    location.pathname.includes("/jdform") ||
    location.pathname.includes("/add_jd") ||
    location.pathname.includes("/edit") ||
    location.pathname.includes("/add_user_copy") ||
    location.pathname.includes("/edit_user") ||
    location.pathname.includes("/add_client") ||
    location.pathname.includes("/add_client_copy") ||
    location.pathname.includes("/edit_client") ||
    location.pathname.includes("/add_user") ||
    location.pathname.includes("/recruiter_performance") ||
    location.pathname.includes("/jd_performance") ||
    location.pathname.includes("/recruiter_ranking_dashboard") ||
    location.pathname.includes("/selection_page");

  return (
    <div className="App">
      <div className="content-wrapper">
        <div className="main-content">
          <Routes>
            {/*Public Routes */}
            <Route path="/ai-recruiter" element={<AiRecruiterPage />} />
            {/* BLOG ROUTES */}
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/signup" element={<SignupPage />} />
            {/* <Route path="/" element={<LandingPage />} /> */}
            <Route path="/set-password" element={<SetPassword />} />
            <Route
              path="/onboarding_form/:candidate_id"
              element={<OnboardingForm />}
            />
            <Route
              path="/candidate_form/:candidate_id"
              element={<CandidateQualificationForm />}
            />
            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/freetrial" element={<FreeTrialModal.js />}></Route>
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin_login" element={<AdminLogin />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/approve_access/:id" element={<ApproveAccess />} />
            <Route path="/forgot_password" element={<ForgotPassword />} />
            <Route path="/reset_password" element={<ResetPassword />} />

            {/* Protected Routes */}
            <Route
              path="/recruiter_performance"
              element={
                <ProtectedRoute>
                  <RecruiterPerformanceDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jd_performance"
              element={
                <ProtectedRoute>
                  <JdPerformanceDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/selection_page"
              element={
                <ProtectedRoute>
                  <ModuleSelectionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recruiter_ranking_dashboard"
              element={<RecruiterRankingDashboard />}
            />

            <Route
              path="/admin_dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add_jd/:id"
              element={
                <ProtectedRoute>
                  <CopyJDForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jdform"
              element={
                <ProtectedRoute>
                  <JdForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit/:id"
              element={
                <ProtectedRoute>
                  <EditForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jd_dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add_user"
              element={
                <ProtectedRoute>
                  <AddUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add_user_copy/:id"
              element={
                <ProtectedRoute>
                  <CopyAddUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit_user/:id"
              element={
                <ProtectedRoute>
                  <EditUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user_dashboard"
              element={
                <ProtectedRoute>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user_confirmation"
              element={
                <ProtectedRoute>
                  <UserConfirmation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add_client"
              element={
                <ProtectedRoute>
                  <AddClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/client_dashboard"
              element={
                <ProtectedRoute>
                  <ClientManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add_client_copy/:id"
              element={
                <ProtectedRoute>
                  <CopyAddClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit_client/:id"
              element={
                <ProtectedRoute>
                  <EditClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/summary_report"
              element={
                <ProtectedRoute>
                  <SummaryReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports_dashboard"
              element={
                <ProtectedRoute>
                  <AllData />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rdash"
              element={
                <ProtectedRoute>
                  <RecruiterDash />
                </ProtectedRoute>
              }
            />
            <Route
              path="/form"
              element={
                <ProtectedRoute>
                  <RJdForm />
                </ProtectedRoute>
              }
            />

            <Route
              path="/matched_results"
              element={
                <ProtectedRoute>
                  <ResumeUpload />
                </ProtectedRoute>
              }
            />

            <Route
              path="/employee_dashboard"
              element={
                <ProtectedRoute>
                  <EmployeeDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/verification_form/:id"
              element={
                <ProtectedRoute>
                  <CandidateVerificationForm />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
        {showFooter && <Footer />}
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LoadingProvider>
        <AppContent />
      </LoadingProvider>
    </BrowserRouter>
  );
}

export default App;
